<ion-card class="profile-popup">
  <ion-card-header>
    <div class="profile-header">
      <div class="avatar">
        <img *ngIf="userProfilePhoto.photo$ | async as photo; else popupInitials" [src]="photo" class="avatar-photo" alt="">
        <ng-template #popupInitials>{{ getInitials() }}</ng-template>
      </div>
      <div class="profile-header-text">
        <div class="name">{{ getUserName() }} {{ dbEncryptionEnabled }}</div>
        <div class="title">{{ userPosition ? userPosition : authService.user.positionName }}</div>
        <div class="email">{{ userEmail ? userEmail : authService.user.mail }}</div>
      </div>
    </div>
  </ion-card-header>

  <ion-card-content [ngClass]="{'ios-device': device.isIOS() && device.isMobileDevicePortrait}">
    <ng-container *ngIf="faService.isShortCallLauncherEnabledInMobileDevice">
      <ion-item class="address" lines="none">
        <ion-icon slot="start" src="assets/imgs/user-location.svg"></ion-icon>
        <span>{{ getUserUserLocation() }}</span>
      </ion-item>
      <div class="separationLine"></div>
    </ng-container>

    <ion-item lines="none" 
    class="status" (click)="openStatusPopover($event)">
      <ion-icon
        #statusIcon
        slot="start"
        name="ellipse"
        [style.color]="userStatus?.color"
        style="font-size: 20px;"
      ></ion-icon>
      <span>{{ userStatus?.statusDisplayTxt }}</span>
      <ion-icon class="arrow-icon16px" name="chevron-down-outline" slot="end"></ion-icon>
    </ion-item>

    <ion-item lines="none" (click)="openSettings()">
      <ion-icon slot="start" src="assets/imgs/user-settings.svg"></ion-icon>
      <span>{{ 'SETTINGS' | translate }}</span>
    </ion-item>

    <ion-item lines="none" (click)="refreshData()" [ngClass]="{'disabled': device.isOffline || backgroundUploadInProgress}">
      <ion-icon slot="start" src="assets/imgs/user-sync.svg"></ion-icon>
      <span>{{ "SYNC" | translate}} - {{ syncDateString }} {{ syncTimeString }}</span>
    </ion-item>

    <ion-item (click)="logout()" lines="none">
      <ion-icon slot="start" src="assets/imgs/user-logout.svg"></ion-icon>
      <span>{{ "LOGOUT" | translate }}</span>
    </ion-item>
  </ion-card-content>
</ion-card>